import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import React from "react";
const AccentBar = (props) => {
    const { color = "#2DDFD5", width = "16px", height = "3px" } = props;
    return (_jsx(Box, { component: "span", sx: {
            backgroundColor: color,
            width,
            height,
            flexShrink: 0,
        } }));
};
export default AccentBar;
